import { useState } from 'react';
import { useDrawer } from '../../../shared/drawer';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { EstadosItvForm } from './estados-itv-form';


export const EstadosItv = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);




    const handleNewAction = () => {
        open('estado-itv.button.new', <EstadosItvForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.estados-itv'}
            newActionTitle={'estado-itv.button.new'}
        >
            <>
                <Table
                    path="/fleet/inspection-states/"
                    deletePath="/fleet/inspection-states/"
                    callBeforeDrawerClosed={handleClose}
                    Form={EstadosItvForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'name',
                            label: 'common.form-label.name'
                        },
                        {
                            key: 'description',
                            label: 'common.form-label.descripcion'
                        },
                        {
                            key: 'state',
                            type:'boolean',
                            label: 'common.label.puede-circular'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};